/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Review_Pro2Inputs */

const en_fc_home_review_pro2 = /** @type {(inputs: Fc_Home_Review_Pro2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premiere-style panels and shortcuts make switching fast.`)
};

/**
* | output |
* | --- |
* | "Premiere-style panels and shortcuts make switching fast." |
*
* @param {Fc_Home_Review_Pro2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_review_pro2 = /** @type {((inputs?: Fc_Home_Review_Pro2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Review_Pro2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_review_pro2(inputs)
});
export { fc_home_review_pro2 as "fc.home.review.pro2" }